// import React, { Component } from 'react';
// import "./header.css"
// import  AuthService  from "../api/authentication.js";

// const Auth = new AuthService();
// class Header extends Component {

//     constructor(props){
//         super(props)
//         this.state={
//           showbuton:false
//         }
//       }
    

    
//   componentDidMount(){
//     if(Auth.loggedIn()){
//         this.setState({
//           showbuton:true
//         })
//     }
//   }


  
//   render() {
//       const stylelogo ={
//         width:"10px"
//       }
//     return (
//       <div className="App">
       
//                 <nav className="navbar costom" role="navigation">
//                     <div className="navbar-brand">
//                         <div className="navbar-item ">
//                            <div className="logo-image">
//                                 <a href="/">
//                                    <img src="http://res.cloudinary.com/easywaya/image/upload/v1537477932/42164731_1927823140853336_3419030160752508928_n_z0qflb.png" width="110"   height="1000" />
//                                  </a>
                              
//                              </div>
//                             {/* <span style={stylelogo}></span> */}
//                         </div>
//                         <div className="button navbar-burger is-active">
//                             <span></span>
//                             <span></span>
//                             <span></span>
//                         </div>
                          
//                     </div>
//                     {/* <div className="logo-image">
//                           <img src="http://2016.igem.org/wiki/images/4/4b/T--NCKU_Tainan--ulogo.png"  width="30" />
//                     </div>   */}
                    
//                     <div className="navbar-menu is-active mobile-nav">
//                         <div className="navbar-end ">
//                             {/* <div className="navbar-item  ">
                           
//                                 <div> <a href="/search"><i className="fas fa-search nav-icon-list"></i></a> </div>
//                             </div> */}
//                             { this.state.showbuton ?
//                                 <div className="navbar-item ">
//                                     <div>
//                                     <a href="/dashboard" className="button is-success pubulc-side-button">   <div className="user-dot"> <i className="far fa-user"></i> </div> </a>
                                    
//                                     </div>
//                                 </div>
//                             :
//                                <samp></samp>
//                             }
//                             <div className="navbar-item ">
//                             <div><i className="fas fa-book-open nav-icon-list"></i></div>
//                                 {/* <div> <i className="fas fa-bullhorn nav-icon-list"></i> Feedback </div> */}
//                             </div>
//                         </div>
                        
//                     </div>
                    
                   
//                 </nav>
//                 {/* <nav className="navbar costom" role="navigation">
                   
//                 </nav> */}
                
                
       
    
//       </div>
//     );
//   }
// }

// export default Header;

import React from 'react';
import PropTypes from 'prop-types';
import  AuthService  from "../api/authentication.js";
import { throws } from 'assert';
import "./header.css"

import {
    BrowserRouter as Router,

    Link,
    
  } from 'react-router-dom'

// import NavbarItem from "./NavbarItem";
// import NavbarBurger from "./NavbarBurger";

const NavbarItem = props => (
  <a className="navbar-item is-capitalized" href={`#${props.page}`}>
    {props.page}
  </a>
);
const NavbarBurger = props => (
  <button
    onClick={props.toggleMenu}
    className={`button navbar-burger ${props.active ? 'is-active' : ''}`}
  >
    <span />
    <span />
    <span />
  </button>
);

const Auth = new AuthService();
export default class Navbar extends React.Component {
  state = {
    activeMenu: false,
    nav1: false
  };
  toggleMenu = () => {
    this.setState({
      activeMenu: !this.state.activeMenu,
    });
  };

  logout=(event)=>{
    event.preventDefault();
    Auth.logout()
   this.props.logout()
}

    openNavItem = () => {
        this.setState({
            nav1: true
        })
    }

  render() {
    // console.log("data this.props.organizers404", this.props.organizers404, this.props.organizer)

    let { pages = [], color } = this.props;
    let navbarItems = pages.map(page => <NavbarItem page={page} key={page} />);
    return (
      // <nav className={`navbar is-fixed-top is-${color}`}>
      //   <div className="navbar-brand">
      //     <NavbarItem page="logo" />
      //     <NavbarBurger
      //       active={this.state.activeMenu}
      //       toggleMenu={this.toggleMenu}
      //     />
      //   </div>
      //   <div
      //     className={`navbar-menu ${this.state.activeMenu ? 'is-active' : ''}`}
      //   >
      //     <div className="navbar-start">{navbarItems}</div>
      //   </div>
      // </nav>
      <div>
         <nav class="main-menu is-dark" style={{ display: `${this.props.isAuthenticated ? 'block' : 'none'}`}}>
            <div class="main-menu-inner" >
                
            
                <ul>
                    <li class="main-logo main-logo-costom">
                        <a href="/" className="head-logo-img"><img src="https://res.cloudinary.com/codepally/image/upload/v1626645776/Ridora/png/unnamed_1_tvmbac.png" alt="" width="300"/></a>
                    </li>
                    
                        {/* <li class="side-icon is-active " data-child-menu="dashboard-menu">
                            <i class="sl sl-icon-speedometer"></i>
                        </li>  */}

                   <a href="/info" style={{display: `${!this.props.organizers404 ? 'block' : 'none'}`}}>
                         <li class="side-icon-costom  is-active " >
                          <i class="sl sl-icon-home"></i>
                           <p style={{fontSize:"70%",color:"white",marginTop:"5px"}}>Company</p>
                        </li> 
                     </a>


                     <a href="/dashboard" style={{display: `${this.props.organizers404 ? 'block' : 'none'}`}}>
                         <li class="side-icon-costom  is-active " >
                          <i class="sl sl-icon-home"></i>
                           <p style={{fontSize:"70%",color:"white",marginTop:"5px"}}>Home</p>
                        </li> 
                     </a>


                   {/*   
                     <a style={{display: `${this.props.organizers404 ? 'block' : 'none'}`}}>
                    <li class="side-icon  " data-child-menu="business-menu" style={{width:"100%",marginBottom:"10px", marginTop:"10px"}}>

                        <i class="sl sl-icon-social-dropbox heard-icon-side">
                        <p className="heard-title-side">Products</p>
                        </i>

                    </li>
                    </a>
                    */}
                    
                    <a  href="/school" style={{display: `${this.props.organizers404 ? 'block' : 'none'}`}}>
                        <li class="side-icon-costom2 " style={{width:"100%",marginBottom:"10px",}}>
                         <i class="sl  sl-icon-graduation"></i>
                         <p className="heard-title-side2">School</p>
                        </li>
                    </a> 
                    <a  href="/setting" style={{display: `${this.props.organizers404 ? 'block' : 'none'}`}}>
                    <li class="side-icon-costom2 " style={{width:"100%",marginBottom:"10px",}}>
                            <i class="sl   sl-icon-settings "></i>
                            <p className="heard-title-side4">Setting</p>
                            
                        
                        </li>
                    </a>
                   
                    {/* <li class="side-icon" data-child-menu="misc-menu">
                    <i class="sl   sl-icon-speech"></i>
                    </li> */}
                     {/*
                    <li class="side-icon" data-child-menu="settings-menu" style={{display: `${this.props.organizers404 ? '' : 'none'}`}}>
                        <i class="sl sl-icon-settings heard-icon-side1">
                        <p className="heard-title-side3">Setting</p>
                        </i>
                     
                    </li>
                    */}

                     


                    <a onClick={this.logout} >
                    <li class="side-icon-costom2 head-icon-power" style={{width:"100%",marginBottom:"10px",}}>
                         <i class="sl  sl-icon-power"></i>
                         <p className="heard-title-side4">Logout</p>
                    </li>
                    </a> 


                </ul>
            
                      
            </div>
        </nav> 

         <nav class="child-menu" style={{ display: `${this.props.isAuthenticated ? 'block' : 'none'}`}}>
            <div class="child-menu-inner" style={{ background:"#00D1B2"}}  >
             
                <ul>
                    <li class="child-header"> 
                        <div class="sidebar-title">Uvune</div>
                        <a id="close-child-menu" class="menu-wrapper">	
                            <span class="icon-box-toggle ef-4"> 	
                                <span class="rotate">
                                    <i class="icon-line-top">  	 </i>
                                    <i class="icon-line-center">  </i>
                                    <i class="icon-line-bottom">  </i> 
                                </span>
                            </span>
                        </a>
                    </li>
                </ul>
             
                <ul id="dashboard-menu" class={`sidebar-menu is-active animated preFadeInRIght fadeInRight`}>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">dashboard</span>Dashboard</a>
                        <ul>
                            <li><a href="dashboard.html">Main layout</a></li>
                            <li><a href="dashboard-blank.html">Blank page</a></li>
                            <li><a href="dashboard-login.html">Login page</a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">insert_chart</span>Analytics</a>
                        <ul>
                            <li><a href="dashboard-chartjs.html">Chart js</a></li>
                            <li><a href="dashboard-billboardjs.html">Billboard js</a></li>
                            <li><a href="dashboard-peityjs.html">Peity js</a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">developer_board</span>Widgets</a>
                        <ul>
                            <li><a href="dashboard-widgets-data.html">Data widgets</a></li>
                            <li><a href="dashboard-widgets-social.html">Social widgets</a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">view_agenda</span>Feed</a>
                        <ul>
                            <li><a href="dashboard-feed.html">Social feed</a></li>
                            <li><a href="dashboard-feed-post.html">Post Item</a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">invert_colors</span>Styles</a>
                        <ul>
                            <li><a href="/">Light sidebar</a></li>
                            <li><a href="dashboard-dark-nav.html">Dark sidebar</a></li>
                        </ul>
                    </li>
                </ul>
               
                {/* <ul id="documents-menu" class="sidebar-menu animated preFadeInRIght fadeInRight"> */}
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">insert_drive_file</span>Activity</a>
                        <ul>
                            <li><a href="javascript:void(0);">Payment <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Customer<span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Invoice <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li> */}
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">assignment</span>Projects</a>
                        <ul>
                            <li><a href="dashboard-project-list.html">Project list <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                            <li><a href="dashboard-project-details.html">Project details <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">assignment_turned_in</span>Tasks</a>
                        <ul>
                            <li><a href="dashboard-project-task.html">Single Task <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                            <li><a href="dashboard-project-mytasks.html">My Tasks<span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Kanban board <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">library_books</span>Forms</a>
                        <ul>
                            <li><a href="javascript:void(0);">Step form <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Steps <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li> */}
                {/* </ul> */}
           
                <ul id="business-menu" class="sidebar-menu animated preFadeInRIght fadeInRight">
                    <li class="have-children"><a class="parent-link" href="#"><i className="sl sl-icon-social-dropbox"></i><span class="material-icons "></span>Product</a>
                        <ul>
                            <li><a href="/products">All Product </a></li>
                            <li><a href="/product-new">New product </a></li>
                            {/* <li><a href="javascript:void(0);">Category <span class="sl sl-icon-lock warning-text ml-10"></span></a></li> */}
                        </ul>
                    </li>
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">folder_open</span>Categores</a>
                    
                    <i class="fas fa-arrows-alt" style={{marginRight:"10px"}}></i> 
                        <ul>
                            <li><a href="/categories">Categores  </a></li>
                            <i class="fab fa-product-hunt"></i>
                            <li><a href="javascript:void(0);"> <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li> */}
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">attach_money</span>Deals</a>
                        <ul>
                            <li><a href="javascript:void(0);">Deals list <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Single Deal <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li> */}
                </ul>
{/*                 
                <ul id="misc-menu" class="sidebar-menu animated preFadeInRIght fadeInRight">
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">grid_on</span>Datatables</a>
                        <ul>
                            <li><a href="dashboard-datatable-basic.html">Basic Datatable <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                            <li><a href="dashboard-datatable-variations.html">Variations <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                            <li><a href="dashboard-datatable-advanced.html">Advanced Example <span class="sl sl-icon-lock-open success-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">speaker_notes</span>Faq</a>
                        <ul>
                            <li><a href="javascript:void(0);">Faq home <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Faq article <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">thumbs_up_down</span>Forum</a>
                        <ul>
                            <li><a href="javascript:void(0);">Forum home <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Forum thread <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">email</span>Mailbox</a>
                        <ul>
                            <li><a href="javascript:void(0);">Inbox <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Compose <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li>
                </ul> */}
            
                <ul id="settings-menu" class="sidebar-menu animated preFadeInRIght fadeInRight">
                  <li class=""><a class="parent-link" href="/setting"><span class="material-icons">settings</span>User profile</a></li>
                  <li class=""><a class="parent-link" href="/company-profile"><span class="material-icons">settings</span>Company profile</a></li>  
                      {/* <li><a href="/setting">User setting</a></li>
                            <li><a href="/company-profile">Organizations setting </a></li> */}
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">settings</span>Global settings</a>
                        <ul>
                           <li><a href="/setting">User setting</a></li>
                            <li><a href="/company-profile">Organizations setting </a></li>

                        </ul>
                    </li> */}
                    {/* <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">account_circle</span>User settings</a>
                        <ul>
                            <li><a href="javascript:void(0);">User list <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Add user <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="javascript:void(0);">Access rights <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li>
                    <li class="have-children"><a class="parent-link" href="#"><span class="material-icons">domain</span>Organizations</a>
                        <ul>
                            <li><a href="javascript:void(0);">Organizations setting <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                            <li><a href="/company-profile">Add organization <span class="sl sl-icon-lock warning-text ml-10"></span></a></li>
                        </ul>
                    </li> */}
                </ul>
            
            </div>
        </nav> 

        <nav class="navbar dashboard-nav has-shadow"  style={{ display: `${this.props.isAuthenticated ? 'block' : 'none'}`}}>
            <div class="container is-fluid">
                {/* <!-- Nav left --> */}
                <div class="navbar-brand">
                    {/* <!-- Logout button --> */}
                    {/* <a onClick={this.logout}>
                    <div class="navbar-item nav-icon logout-button" style={{position:"relative",left:"30px"}}>
                      <i class="sl sl-icon-power"></i> 
                    </div>
                    </a> */}
                    {/* <!-- /Logout button -->
        
                    <!-- Reader mode switch --> */}
                    <div class="navbar-item reader-switch is-hidden-desktop is-hidden-tablet">
                        <div class="field">
                            <input id="reader-mode-switch" type="checkbox" name="reader-mode-switch" class="switch is-outlined is-primary is-small"/>
                            <label id="reader-mode-toggle" for="reader-mode-switch"></label>
                        </div>
                    </div>
                    {/* <!-- Reader mode switch -->
        
                    <!-- Collaborators list (hidden on mobile) --> */}
                   
                    {/* <!-- /Quick search -->
        
                    <!-- Global search (visible on mobile only) --> */}
                   {/*  <div class="navbar-item nav-icon search-icon modal-trigger is-hidden-desktop is-hidden-tablet" data-modal="search-modal">
                        <i class="sl sl-icon-magnifier"></i>
                    </div>
                    */}
                    
                    {/* <!-- /Global search -->
        
                    <!-- Right sidebar trigger (visible on mobile only)  --> */}
                    {/* <div class="navbar-item nav-icon chat-button is-hidden-desktop is-hidden-tablet" data-show="quickview" data-target="main-quickview">
                        <i class="im im-icon-Speach-Bubble11"></i>
                    </div> */}

                    {/* <!-- /Right sidebar trigger --> */}
                </div>
                {/* <!-- /Nav left -->
        
                <!-- Nav right --> */}
                <div class="navbar-menu">
                    <div class="navbar-end costom-navbar-end" >
                        
                        {/* <!-- Notifications dropdown (hidden on mobile) --> */}
                        <div class="navbar-item drop-pop is-centered nav-icon">
                            {/* <a href="#" class="nav-inner">
                                <i class="sl sl-icon-bell"><span class="new-circle gelatine"></span></i>
                            </a> */}
                            <div class="drop-wrapper notifications-drop">
                                <div class="drop-inner has-arrow">
                                    <div class="notifications-header has-text-centered">
                                        <h3>Notifications</h3>
                                    </div>
                                    <div class="notifications-body">
                                        <ul class="notifications-list">
                                            <li>
                                                <i class="sl sl-icon-heart"></i>
                                                <div class="notification-content">
                                                    <img src="https://via.placeholder.com/250x250" alt=""/>
                                                    <div class="notification-text">
                                                        <div class="text">
                                                            <b>Henry</b> liked your <b>comment</b>.
                                                        </div>
                                                        <div class="timestamp">
                                                            23 minutes ago
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <i class="sl sl-icon-check"></i>
                                                <div class="notification-content">
                                                    <img src="https://via.placeholder.com/250x250" alt=""/>
                                                    <div class="notification-text">
                                                        <div class="text">
                                                            <b>Marjory</b> followed you.
                                                        </div>
                                                        <div class="timestamp">
                                                            1 hour ago
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <i class="sl sl-icon-heart"></i>
                                                <div class="notification-content">
                                                    <img src="https://via.placeholder.com/250x250" alt=""/>
                                                    <div class="notification-text">
                                                        <div class="text">
                                                            <b>Marc</b> commented one of your tasks.
                                                        </div>
                                                        <div class="timestamp">
                                                            Yesterday
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /Notifications dropdown -->
                        <!-- Messages dropdown (hidden on mobile) --> */}
                        <div class="navbar-item drop-pop is-centered nav-icon">
                            {/* <a href="#" class="nav-inner">
                                <i class="sl sl-icon-envelope-open"><span class="new-circle gelatine"></span></i>
                            </a> */}
                            {/* <a href="#" class="nav-inner">
                                <i class="sl sl-icon-envelope-open"><span class="new-circle gelatine"></span></i>
                            </a> */}
                            <div class="drop-wrapper emails-drop">
                                <div class="drop-inner has-arrow">
                                    <div class="emails-header has-text-centered">
                                        <h3>Messages</h3>
                                    </div>
                                    <div class="emails-body">
                                        <ul class="emails-list">
                                            <li>
                                                <img src="https://via.placeholder.com/250x250" alt=""/>
                                                <div class="email-content">
                        
                                                    <div class="email-text">
                                                        <div class="text">
                                                            Hello, after our last meetings, it seems that some goals were...
                                                        </div>
                                                        {/* <!--div class="timestamp">
                                                            Nov 09, 14:18
                                                        </div--> */}
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <span class="fake-avatar is-secondary">B</span>
                                                <div class="email-content">
                                                    <div class="email-text">
                                                        <div class="text is-read">
                                                            We did not receive the order yet, can you please check if it has...
                                                        </div>
                                                        {/* <!--div class="timestamp">
                                                            Nov 05, 13:31
                                                        </div--> */}
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <span class="fake-avatar is-primary">J</span>
                                                <div class="email-content">
                                                    <div class="email-text">
                                                        <div class="text is-read">
                                                            My boss was very grateful that you found a solution during the week as...
                                                        </div>
                                                        {/* <!--div class="timestamp">
                                                            Nov 05, 09:47
                                                        </div--> */}
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Messages dropdown --> */}
                        {/* <!-- Global search (desktop and tablet only) --> */}
                        {/* <div class="navbar-item nav-icon search-icon modal-trigger " >
                            <i class="sl sl-icon-magnifier"></i>
                        </div> */}
                        {/* <!-- /Global search --> */}
        
                        {/* <!-- Right sidebar trigger (desktop and tablet only) --> */}
                        <div class="navbar-item nav-icon chat-button"  style={{ display: `${this.props.organizer.verified ? '' : 'none'}`}}>
                           <a href={'https://uvune.com/company?id='+this.props.organizer._id} target="_blank"><i class="sl  sl-icon-eye"  ></i></a> 
                        </div>
                        {/* <!-- /Right sidebar trigger --> */}
                    </div>
                </div>
                {/* <!-- /Nav right --> */}
            </div>
        </nav>

        </div>
    );
  }
}

Navbar.propTypes = {
  pages: PropTypes.array.isRequired,
  color: PropTypes.string,
};








// WEBPACK FOOTER //
// ./src/component/header/header.js